import { GetNpsVisibilityDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useFetchShouldShowNps = (id: string) => {
  const { data, loading } = useQuery(GetNpsVisibilityDocument, {
    variables: {
      id: id,
    },
  })

  return {
    shouldShow: data?.nps.widgetVisibility?.shouldSee,
    loading,
  }
}
